/* Carousel input. Separate file so an error in the main bundle can't stop it.
   Per spec: no vertical-scroll hijack, fixed scroll distances, arrows only. */
window.__duoCarousel = 'loaded';

(function () {
  var t = document.getElementById('fcTrack');
  if (!t) return;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function slideW() {
    var a = t.children[0], b = t.children[1];
    return (a && b) ? (b.offsetLeft - a.offsetLeft) : t.clientWidth;
  }
  function nearest() { return Math.round(t.scrollLeft / slideW()); }
  function goTo(i, smooth) {
    var n = t.children.length - 1;
    i = Math.max(0, Math.min(n, i));
    t.style.scrollSnapType = 'none';
    t.scrollTo({ left: Math.min(slideW() * i, t.scrollWidth - t.clientWidth),
                 behavior: (smooth && !reduce) ? 'smooth' : 'auto' });
  }

  /* drag, always settling on a slide */
  var down = false, moved = false, x0 = 0, s0 = 0, lastX = 0, lastT = 0, vel = 0;
  t.style.cursor = 'grab';
  t.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'touch') return;
    down = true; moved = false;
    x0 = lastX = e.clientX; s0 = t.scrollLeft; lastT = performance.now(); vel = 0;
    t.style.scrollSnapType = 'none'; t.style.cursor = 'grabbing';
    try { t.setPointerCapture(e.pointerId); } catch (_) {}
  });
  t.addEventListener('pointermove', function (e) {
    if (!down) return;
    var dx = e.clientX - x0;
    if (Math.abs(dx) > 3) moved = true;
    var now = performance.now(), dt = now - lastT;
    if (dt > 0) vel = (e.clientX - lastX) / dt;
    lastX = e.clientX; lastT = now;
    t.scrollLeft = s0 - dx;
  });
  function release(e) {
    if (!down) return;
    down = false; t.style.cursor = 'grab';
    try { t.releasePointerCapture(e.pointerId); } catch (_) {}
    var i = nearest();
    if (vel < -0.35) i = Math.ceil(t.scrollLeft / slideW());
    else if (vel > 0.35) i = Math.floor(t.scrollLeft / slideW());
    goTo(i, true);
  }
  t.addEventListener('pointerup', release);
  t.addEventListener('pointercancel', release);
  t.addEventListener('pointerleave', release);
  t.addEventListener('click', function (e) {
    if (moved) { e.preventDefault(); e.stopPropagation(); }
  }, true);
})();
